module.exports = __webpack_public_path__ + "img/icon-over.abac9804.png";